import { render, staticRenderFns } from "./DictItemModal.vue?vue&type=template&id=6fc3dfdf"
import script from "./DictItemModal.vue?vue&type=script&lang=js"
export * from "./DictItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports